<template>
   <div class="mdrichedit-container" v-if="isMounted">
     <div class="mdrichedit-wrapper">
       <BaseInputWithContextMenu
          :ref="'contextMenuBaseForRichEdit_' + inputElementId"
          :target-id="inputElementId"
          :is-read-only="isReadOnlyState"
          :value="value"
          :enable-speech-features="true"
          :enable-system-options="true"
          @input="onEditorInput"
          @control-changed="setChangedStatus"
          :control-id="Name"
          :is-ckeditor="true"
        >
        <ckeditor
            :ref="'ckeditorInstance_' + inputElementId"
            v-bind:value="value"
            :config="this.editorConfig"
            v-bind:read-only="this.readOnly"
            :id="inputElementId"
            @input="onEditorInput"
            @blur="onEditorBlur"
            :editor-url="editorUrl"
            @ready="onEditorReady"
            v-bind:style="style">
        </ckeditor>
       </BaseInputWithContextMenu>

     </div>

     <b-modal
       v-model="showAiPanel"
       :id="'ai-writer-modal-re-' + inputElementId"
       :title="$t('AiWriter.Title')"
       hide-footer
       size="md"
       @shown="makeAiModalDraggable"
       @hidden="resetAiPanel"
     >
       <div class="ai-writer-body">
         <label class="ai-label">{{ $t('AiWriter.WhatToWrite') }}</label>
         <b-form-textarea
           ref="aiInstructionInput"
           v-model="aiInstruction"
           :placeholder="$t('AiWriter.Placeholder')"
           rows="3"
           class="ai-instruction-input"
           :disabled="isGenerating"
         ></b-form-textarea>

         <div class="mt-2 d-flex justify-content-end">
           <b-button
             variant="primary"
             size="sm"
             :disabled="isGenerating || !aiInstruction.trim()"
             @click="generateText"
           >
             <span v-if="isGenerating">{{ $t('AiWriter.Generating') }}</span>
             <span v-else>{{ $t('AiWriter.Generate') }}</span>
           </b-button>
         </div>

         <div v-if="aiError" class="mt-2 text-danger small">{{ aiError }}</div>

         <div v-if="aiGeneratedText" class="ai-preview mt-3">
           <label class="ai-label">{{ $t('AiWriter.GeneratedText') }}</label>
           <b-form-textarea
             v-model="aiGeneratedText"
             class="ai-preview-text"
             rows="5"
             max-rows="10"
           ></b-form-textarea>
           <div class="mt-2 d-flex justify-content-end">
             <b-button variant="primary"           size="sm" class="mr-1" @click="aiInsertText">{{ $t('AiWriter.Insert') }}</b-button>
             <b-button variant="outline-primary"   size="sm" class="mr-1" @click="aiReplaceText">{{ $t('AiWriter.Replace') }}</b-button>
             <b-button variant="outline-primary"   size="sm" class="mr-1" :disabled="isGenerating" @click="generateText">{{ $t('AiWriter.Regenerate') }}</b-button>
             <b-button variant="outline-secondary" size="sm" @click="closeAiWriter">{{ $t('AiWriter.Discard') }}</b-button>
           </div>
         </div>
       </div>
     </b-modal>
    </div>
</template>

<script>
  import { EventBus } from '@/event-bus.js';
  import GlobalService from '@/services/global.service'
  import ApiService from '@/services/api.service';
  import Vue from 'vue';
  import { ContextMenuPlugin } from "@syncfusion/ej2-vue-navigations";

  Vue.use(ContextMenuPlugin);
  export default {
    name: 'MdRichEdit',
   props: {     
     isReadOnly:Boolean,
     value:[String, Number],
     Name:String,
     Tag: String,
     Height: [String, Number],
     id: [String, Number],
     HideToolBar: Boolean,
     StartupFocus: {
      default: true,
      type: Boolean
     },
     isRequired: Boolean,
     isValid:Boolean,
   },
    watch: {
      isValid: function (newValue) {
        this.setValid(newValue)
      },

      isReadOnly: function (newValue) {
        if (this.editor && this.readOnly != newValue) {
            this.readOnly = newValue;
        }
      }
    },
    data() {
      return {
        readOnly: this.isReadOnly,
        editorUrl: '/ckeditor/ckeditor.js',
        editor: null,
        editorConfig: {
          hideTB: this.HideToolBar,
          on: {
                instanceReady : function ( evt )
                {
                  //Hide toolbar
                  if (evt.editor.config.hideTB) {
                    let edId = evt.editor.id.split('_')[1]
                    document.getElementById( `cke_${edId}_top` ).style.display = 'none';
                  }
                },
                
                paste: async function(evt) {
                  let rtfData = evt.data.dataTransfer.getData( 'text/rtf', true);
                  const filesCount = evt.data.dataTransfer.getFilesCount()
                  const textData = evt.data.dataTransfer.getData( 'Text', true);
                  const htmlData = evt.data.dataTransfer.getData( 'text/html', true);
                  let rtfContent= { rtf:[] }
                  if(!textData && !htmlData && filesCount > 0){
                    let imagen = evt.data.dataTransfer.getFile(0);
                    let reader = new FileReader();
                    reader.onload = function(e) {
                      let element = evt.editor.document.createElement('img', {
                        attributes: {
                          src: e.target.result
                        }
                      });
                      evt.editor.insertElement(element);             
                    };
                    reader.readAsDataURL(imagen);
                  }

                  if(filesCount == 0 && rtfData && !htmlData){
                    evt.cancel();
                    rtfData = rtfData.replaceAll(/\\\*\\fldinst HYPERLINK .*"/g,'');
                    rtfData = rtfData.replaceAll('>', '');
                    rtfData = rtfData.replaceAll('<', '');
                    rtfContent.rtf[0] = rtfData
                    await GlobalService.RtfToHtml(rtfContent)
                      .then(( response) => {
                        if(response.status == '200'){
                            this.htmlContent = response.data.html[0];
                            evt.editor.insertHtml(this.htmlContent);
                        }
                      })
                      .catch((error) => {
                        if(error.response) {
                          evt.cancel();
                        }
                      });
                  }
                }
              },
          title: false,
          toolbar: [ 
            {
              name: 'basicstyles',
              items: ['Bold','Italic','Underline','Strike','-','NumberedList','BulletedList']
            },
            {
              name: 'color',
              items: ['TextColor','BGColor']
            },
            {
              name: 'insert',
              items: ['Table','Link']
            },
           ],
          startupFocus: this.StartupFocus,
          height: this.Height ? this.Height : 'auto',
          extraPlugins: 'tableresize,divarea',
          removePlugins: 'save,smiley,forms,flash,templates,print,preview,iframe,find,exportpdf,\
                          specialchar,pagebreak,wsc,scayt,liststyle,div,a11yhelp,\
                          about,language,indentblock,font,bidi,removeformat,sourcearea,\
                          maximize,htmlwriter,horizontalrule,format,resize,showblocks,\
                          stylescombo,blockquote,copyformatting,selectall,newpage,justify,elementspath',
          removeButtons: 'Subscript,Superscript,Cut,Copy,Outdent,Indent,PasteText,PasteFromWord',
          readOnly: this.isReadOnly,
          extraAllowedContent : 'img(*){*}[*]',
          enterMode: 2,
          shiftEnterMode: 2
        },
        isLoadingCkeditor: true,
        Invalid: false,
        style: {
          border: 'solid 1px #e0e0e0 !important',
          borderColor: '#e0e0e0 !important',
        },
        isMounted: false,
        menuItems:[],
        // AI Writer
        showAiPanel: false,
        aiInstruction: '',
        aiGeneratedText: '',
        aiError: '',
        isGenerating: false,
      }
    },
    computed: {
      inputElementId() {
        return this.id;
      },
      
      isReadOnlyState() {
        return  this.isReadOnly;
      }
    },
    methods:{
        getPlaintText() {
            return this.editor.editable().getText();
        },

        insertText(text) {
            this.editor.editable().insertText(text);
            this.editor.focus();

            this.$emit('input', this.editor.editable().getHtml());
            this.setChangedStatus();
        },

        appendText(text) {
            this.editor.editable().appendText(text);
            this.editor.focus();
            this.moveToLastPosition();

            this.$emit('input', this.editor.editable().getHtml());
            this.setChangedStatus();
        },

        insertHtml(text) {
            this.editor.editable().insertHtml(text);
            this.editor.focus();

            this.$emit('input', this.editor.editable().getHtml());
            this.setChangedStatus();
        },

        appendHtml(text) {
            this.editor.editable().appendHtml(text);
            this.editor.focus();
            this.moveToLastPosition();

            this.$emit('input', this.editor.editable().getHtml());
            this.setChangedStatus();
        },

        moveToLastPosition() {
            const range = this.editor.createRange();
            range.moveToElementEditablePosition(range.root, true);
            this.editor.getSelection().selectRanges([range]);
        },

      setChangedStatus(){
        var changed = {
          "Changed":true,
        }
        EventBus.$emit('onChanged', changed);
      },

      updateValue(newValue) {
        this.$emit('input', newValue);
      },

      onEditorReady(editor){
        this.editor = editor;
        if (editor.contextMenu) {
          editor.removeMenuItem('cut');
          editor.removeMenuItem('copy');
          editor.removeMenuItem('paste');
        }
        this.isLoadingCkeditor = false
        if (this.editorConfig.readOnly != this.isReadOnly) {
            this.readOnly = this.isReadOnly;
        }

        if (!this.isReadOnly && this.$store.state.useAIAssist) {
          const edId = editor.id.split('_')[1];
          const toolbar = document.getElementById(`cke_${edId}_top`);
          if (toolbar) {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.title = this.$t('AiWriter.HelpMeWrite');
            btn.style.cssText = 'background:none;border:none;padding:2px 4px;cursor:pointer;vertical-align:middle;line-height:1;float:right;margin-top:4px;';
            btn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#19BEE8" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5Z"/>
              <path d="M19 15l.75 2.25L22 18l-2.25.75L19 21l-.75-2.25L16 18l2.25-.75Z"/>
              <path d="M5 3l.5 1.5L7 5l-1.5.5L5 7l-.5-1.5L3 5l1.5-.5Z"/>
            </svg>`;
            btn.addEventListener('click', () => this.openAiWriter());
            btn.addEventListener('mouseenter', () => { btn.style.filter = 'brightness(1.2)'; });
            btn.addEventListener('mouseleave', () => { btn.style.filter = ''; });
            toolbar.appendChild(btn);
          }
        }

        this.onSendEditor(editor);
        this.$emit('ready',editor);
      },

      getControlId() {
        return this.Name;
      },

      onEditorInput(value){
        this.$emit('input',value);
        if (!this.isLoadingCkeditor && !value.includes('rtf1')) {
          this.setChangedStatus()
        }
        
        const plaintText = this.editor ? this.getPlaintText() : value;
        this.Invalid = plaintText.trim().length == 0 && this.isRequired ? true : false;
        this.style.borderColor = this.Invalid ? '#dc3545 !important': '#e0e0e0 !important'
      },

      onEditorBlur(){
        this.$emit('blur',this.value)
        const plaintText = this.editor ? this.getPlaintText() : this.value;
        this.Invalid = plaintText.trim().length == 0 && this.isRequired ? true : false;
        this.style.borderColor = this.Invalid ? '#dc3545 !important': '#e0e0e0 !important'
        // Emit current editor data on blur to capture text inserted externally
        // (e.g. third-party dictation tools that write directly to the DOM
        // without firing the input event)
        if (this.editor) {
          const data = this.editor.getData();
          if (data !== this.value) {
            this.$emit('input', data);
            this.setChangedStatus();
          }
        }
      },

      setValid(state) {
        this.isValid = state;
        this.style.borderColor = state ? '#e0e0e0 !important' : '#dc3545 !important'
      },

   
      setValueS2T( sp ){
        let sp2t = ''
        if(this.value) {
          sp2t += Array.from (this.value +""+ sp).join("");
        } else {
          sp2t = Array.from (sp).join("");
        }
        this.Value = sp2t
        this.$emit('input', sp2t); 
        this.setChangedStatus( sp2t )
      },

      makeAiModalDraggable() {
        this.$nextTick(() => {
          const modalId = 'ai-writer-modal-re-' + this.inputElementId;
          const outer = document.getElementById(`${modalId}___BV_modal_outer_`);
          const dialog = outer?.querySelector('.modal-dialog');
          const header = outer?.querySelector('.modal-header');
          if (!dialog || !header) return;
          header.style.cursor = 'move';
          let dragging = false, offsetX = 0, offsetY = 0;
          header.onmousedown = (e) => {
            e.preventDefault();
            const rect = dialog.getBoundingClientRect();
            offsetX = e.clientX - rect.left;
            offsetY = e.clientY - rect.top;
            dragging = true;
            dialog.style.position = 'fixed';
            dialog.style.margin = '0';
            dialog.style.transform = 'none';
            dialog.style.width = `${rect.width}px`;
            dialog.style.left = `${rect.left}px`;
            dialog.style.top = `${rect.top}px`;
          };
          document.onmousemove = (e) => {
            if (!dragging) return;
            dialog.style.left = `${e.clientX - offsetX}px`;
            dialog.style.top = `${e.clientY - offsetY}px`;
          };
          document.onmouseup = () => { dragging = false; };
          this.$refs.aiInstructionInput.focus();
        });
      },

      openAiWriter() {
        this.showAiPanel = true;
      },

      closeAiWriter() {
        this.showAiPanel = false;
      },

      resetAiPanel() {
        this.aiInstruction = '';
        this.aiGeneratedText = '';
        this.aiError = '';
        this.isGenerating = false;
      },

      async generateText() {
        if (!this.aiInstruction.trim()) return;
        this.isGenerating = true;
        this.aiError = '';
        this.aiGeneratedText = '';
        try {
          const plainText = this.editor ? this.editor.editable().getText() : (this.value || '');
          const payload = { instruction: this.aiInstruction };
          if (plainText.trim()) payload.existingText = plainText;
          const response = await ApiService.post('AiAssist', payload);
          this.aiGeneratedText = response.data.generatedText || '';
        } catch {
          this.aiError = this.$t('AiWriter.Error');
        } finally {
          this.isGenerating = false;
        }
      },

      aiInsertText() {
        if (this.editor) {
          this.editor.editable().appendText('\n' + this.aiGeneratedText);
          this.editor.focus();
          this.$emit('input', this.editor.editable().getHtml());
          this.setChangedStatus();
        }
        this.closeAiWriter();
      },

      aiReplaceText() {
        if (this.editor) {
          this.editor.setData(this.aiGeneratedText);
          this.$emit('input', this.editor.getData());
          this.setChangedStatus();
        }
        this.closeAiWriter();
      },

      onSendEditor(editor) {
        const refName = 'ckeditorInstance_' + this.inputElementId;
        const ckeditorWrapper = this.$refs[refName];

        // Always prioritize packaging if it exists.
        const refToPass = ckeditorWrapper
          ? ckeditorWrapper
          : { instance: editor }; // fallback supported by getActiveEditor

        const contextRef = this.$refs[`contextMenuBaseForRichEdit_${this.inputElementId}`];
        if (contextRef && typeof contextRef.setCKEditorRef === 'function') {
          contextRef.setCKEditorRef(refToPass);
        } else {
          console.warn(`[MdEdit] ⚠️ No se pudo vincular CKEditorRef para ${this.inputElementId}`);
        }
      }

    },
    mounted(){
      this.$nextTick(() => {
        this.isMounted = true;
      });
    },
    
    created() {
        EventBus.$on("receivedS2T", function (event) {
          if( event.ControlId == this.Name) { 
              this.setValueS2T( event.finalSentence )
          }
        }.bind(this))
    }
  }
</script>
<style scoped>
.scroll{
	overflow: hidden !important;
}
.cke_inner .cke_top {
  display: block;
}
.cke_inner, .cke_wysiwyg_frame, .cke_wysiwyg_div{
  background: transparent !important;
}
.cke_chrome {
  border: 0 !important;
}


.ai-label {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  margin-bottom: 4px;
  display: block;
}

.ai-instruction-input {
  font-size: 13px;
}

.ai-preview {
  border-top: 1px solid #e0e0e0;
  padding-top: 12px;
}

.ai-preview-text {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 10px 12px;
  font-size: 13px;
  white-space: pre-wrap;
  max-height: 200px;
  overflow-y: auto;
}
</style>